
import { PropType, defineComponent } from 'vue';
import { GlobalAlertTypes } from '@momnt-technologies/common-ui/lib/plugins/alerts/types';
import CustomButton from '~/components/Buttons/CustomButton.vue';
import CustomDialog from '~/components/Dialogs/CustomDialog.vue';
import { PaymentProviderBankDetails } from '@/interfaces/bank-account';
import { PaymentProviderCardDetails } from '@/interfaces/payment-options';

export default defineComponent({
  name: 'ManagePaymentMethod',

  components: { CustomButton, CustomDialog },

  props: {
    paymentMethod: {
      required: true,
      type: Object as PropType<PaymentProviderBankDetails | PaymentProviderCardDetails>
    },
  },

  data: () => ({
    showConfirmationDialog: false,
    action: 'remove' as 'remove' | 'replace',
    loading: false,
  }),

  computed: {
    paymentMethodType(): 'bank' | 'card' {
      return (<PaymentProviderBankDetails> this.paymentMethod).bank_account_type !== undefined ? 'bank' : 'card';
    },

    lastFour(): string {
      return (<PaymentProviderBankDetails> this.paymentMethod).bank_account_last_4
      || (<PaymentProviderCardDetails> this.paymentMethod).card_last_4;
    }
  },

  methods: {
    confirmRemove() {
      this.action = 'remove';
      this.showConfirmationDialog = true;
    },

    confirmReplace() {
      this.action = 'replace';
      this.showConfirmationDialog = true;
    },

    async onConfirm() {
      this.loading = true;
      try {
        await this.$store.dispatch('PaymentOptions/removePaymentMethod', {
          id: this.paymentMethod.id as string,
          type: this.paymentMethodType,
        });

        if (this.action === 'remove') {
          this.$alerts.add({
            type: GlobalAlertTypes.SUCCESS,
            text: `You have successfully removed ${this.paymentMethodType === 'bank' ? 'bank account' : 'debit card'}
           ending in ${this.lastFour}`,
            timed: true,
          });
        }

        this.$emit(this.action);
      } catch {
        this.$alerts.add({
          type: GlobalAlertTypes.ERROR,
          text: 'There was an error while removing this payment option',
          timed: true,
        });
      } finally {
        this.loading = false;
        this.showConfirmationDialog = false;
        await this.$store.dispatch('PaymentOptions/getPaymentOptions');
      }
    }
  },
});
